<template>
    <div>
        <div v-if="hasErrors('choosen_menus')">
            <div class="invalid-feedback d-block" v-for="(error, index) in formErrors.errors.choosen_menus" :key="index">
                {{ error }}
            </div>
        </div>
        <div class="one-menu mb-1" v-for="menu in parsedMenus" :key="menu.id">
            <div class="row text-start mb-0">
                <div class="col-sm-8">
                    <label :for="`booking-menu-${menu.id}`" class="form-label mb-1">
                        {{ menu.name }}{{ menu.price ? ` - ${formatCurrency(menu.price, getRestaurantCurrency(restaurantId))}` : "" }}
                    </label>
                    <small class="d-block text-muted mb-2">
                        {{ menu.description }}
                    </small>
                </div>
                <div class="col-sm-4">
                    <select
                        :id="`booking-menu-${menu.id}`"
                        style="height: 44px"
                        class="form-select align-middle d-inline-block"
                        :ref="`ref_menu_${menu.id}`"
                        :class="{ 'is-invalid': hasErrors('choosen_menus') }"
                        :value="menu.quantity"
                        @change="chooseMenu(menu, $event)">
                        <option :value="0">0</option>
                        <option v-for="nb in menusLeftToChoose(menu.quantity)" :value="nb" :key="nb">
                            {{ nb }}
                        </option>
                    </select>
                </div>
            </div>
            <div v-if="menu.quantity > 0 && menu.options.length > 0" class="p-3 border-end-light border-bottom-light border-start-light">
                <div class="row text-start mb-0" v-for="option in menu.options" :key="option.id">
                    <div class="col-8">
                        <label :for="`booking-menu-option-${menu.id}-${option.id}`" class="form-label mb-0">
                            {{ option.name }}{{ option.price ? ` - ${formatCurrency(option.price, getRestaurantCurrency(restaurantId))}` : "" }}
                            <small v-if="option.quantity_type === 'mandatory_for_each'" class="text-muted"> ({{ $tl("labels.perPerson") }}) </small>
                        </label>
                        <small class="d-block text-muted">
                            {{ option.description }}
                        </small>
                    </div>
                    <div class="col-4">
                        <div v-if="option.quantity_type === 'mandatory_for_each'">
                            <select
                                :id="`booking-menu-option-${menu.id}-${option.id}`"
                                v-model.number="option.quantity"
                                :ref="`ref_option_${menu.id}${option.id}`"
                                class="form-select align-middle d-inline-block">
                                <option value="0">--</option>
                                <option :value="menu.quantity">
                                    {{ menu.quantity }}
                                </option>
                            </select>
                        </div>

                        <select
                            v-else-if="option.quantity_type === 'limited_by_pers'"
                            :id="`booking-menu-option-${menu.id}-${option.id}`"
                            v-model.number="option.quantity"
                            class="form-select align-middle d-inline-block"
                            :ref="`ref_option_${menu.id}${option.id}`">
                            <option value="0">0</option>
                            <option v-for="nbOption in menu.quantity" :key="nbOption" :value="nbOption">
                                {{ nbOption }}
                            </option>
                        </select>

                        <input
                            v-else-if="option.quantity_type === 'unlimited'"
                            :id="`booking-menu-option-${menu.id}-${option.id}`"
                            v-model.number="option.quantity"
                            class="form-control mb-2"
                            type="number"
                            step="1"
                            min="0"
                            :ref="`ref_option_${menu.id}${option.id}`" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { buildMenuChoices, limitMenuChoices } from "./reservationFormState.mjs";
export default {
    props: {
        available_menus: {
            default: null,
        },
        are_menus_unique: {
            default: false,
        },
        reservation: {
            type: Object,
            required: true,
        },
        nb_total: {
            default: 0,
        },
        formErrors: {
            default: null,
        },
        restaurantId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            parsedMenus: [],
        };
    },
    created() {
        this.parsedMenus = buildMenuChoices(this.available_menus, this.reservation);
        limitMenuChoices(this.parsedMenus, this.nb_total);
    },
    watch: {
        nb_total(value) {
            limitMenuChoices(this.parsedMenus, value);
        },
        parsedMenus: {
            deep: true,
            handler(newValue) {
                this.reservation.choosen_menus = newValue;
            },
        },
    },
    methods: {
        menusLeftToChoose(menuQuantity) {
            return Math.max(0, this.nb_total - this.parsedMenus.reduce((sum, menu) => sum + Number(menu.quantity), 0) + Number(menuQuantity));
        },
        chooseMenu(menu, event) {
            menu.quantity = Math.min(this.menusLeftToChoose(menu.quantity), Math.max(0, parseInt(event.target.value, 10) || 0));
            limitMenuChoices(this.parsedMenus, this.nb_total);
        },
        hasErrors(name) {
            return this.formErrors && this.formErrors.errors && !this.$_.isEmpty(this.formErrors.errors[name]);
        },
    },
};
</script>
